import { Option, OptionKey } from '@common-fe/common-fe';

/**
 * Shared types for the SubstantiationRateStatistic module.
 * Used by the container, the presentational component, the logic hook and their tests.
 */
export enum SubstantiationRateRange {
  YTD = 'YTD',
  NinetyDays = 'NinetyDays',
  ThirtyDays = 'ThirtyDays',
}

export interface SubstantiationRateStatisticProps {
  isLoading?: boolean;
  percents?: number | null;
  options: Option[];
  currentRange: OptionKey;
  onChangeRange: (value: OptionKey) => void;
}
